export default __webpack_public_path__ + "static/media/789712715685691432.d52392b0.png";